import { required, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      transaction_date: {
        required: helpers.withMessage(i18n.global.t('Please enter a transaction date.'), required)
      },
      branch_id: {
        required: helpers.withMessage(i18n.global.t('Please select branch.'), required)
      },
      stock_adjustment_reason_id: {
        required: helpers.withMessage(i18n.global.t('Please select stock adjustment reason.'), required)
      },
      note: {},
      items: {
        required: helpers.withMessage(i18n.global.t('Please add at least one item.'), required)
      }
    }
  }
};
